<template>
	<div id="behavioural" class="module module--consumer-highlights">
		<BgBox src="header-behaviour-2022" :opacity="Number(.3)" :alt="_translate('m.behavioural.background.alt')" parallax>
			<div class="intro intro--constrained">
			<h2>{{ _translate('m.behavioural.title') }}</h2>
				<p v-html="_translate('m.behavioural.intro')"></p>
			</div>
		</BgBox>
		<div class="module__body">
			<div class="container">
				<div class="wrapper">

					<!-- Home Buying Stages -->
					<section id="homebuying">
						<div class="grid grid--inverted-paired">
							<div class="grid__item">
								<h3>{{ _translate('m.stages.title.a')}}</h3>
								<p v-html="_translate('m.stages.intro.a')"></p>
							</div>
							<div class="grid__item">
								<Illustration class="centered" name="buying-stages" fx />
							</div>
						</div>
						<div class="grid grid--inverted-paired">
							<div class="grid__item">
								<h3>{{ _translate('m.stages.title.b')}}</h3>
								<p v-html="_translate('m.stages.intro.b')"></p>
							</div>
							<div class="grid__item">
								<!-- <Illustration class="centered" name="buying-stages" fx /> -->
							</div>
						</div>
					</section>

					<section>
						<BehaviourChart />
					</section>

					<section id="covidimpact">
						<div class="grid grid--paired">
							<div class="grid__item">
								<h3 v-html="_translate('m.usage.covid.title')"></h3>
								<p v-html="_translate('m.usage.covid.a')"></p>
								<p v-html="_translate('m.usage.covid.b')"></p>
							</div>
							<div class="grid__item">
								<p v-html="_translate('m.usage.covid.c')"></p>
							</div>
						</div>
						<div class="grid--single">
						<Card>
							<template v-slot:front>
								<div class="covid-chart">
									<h4 v-html="_translate('m.usage.covid.graphtitle')"></h4>
									<BarChart color="blue" :data="getCovidData" :basis="Number(55)" :scale="[0,10,20,30,40,50]" percentage />
								</div>
							</template>
						</Card>
						</div>
					</section>

					<!-- Website Usage -->
					<section id="websiteusage">
						<h3>{{ _translate('m.usage.title')}}</h3>
						<p class="emphasis" v-html="_translate('m.usage.intro.c')"></p>
						<div class="grid grid--paired">
							<div class="grid__item">
								<Card class="padding-min">
										<template v-slot:front>
											<Illustration name="realtor-users" />
											<div class="card__details">
												<p class="stat" v-html="_translate('m.usage.card.a.stat')"></p>
												<p v-html="_translate('m.usage.card.a.text')"></p>
											</div>
										</template>
								</Card>
								<p class="text-align-center" v-html="_translate('m.usage.intro.a')"></p>
							</div>
							<div class="grid__item">
								<Card class="padding-min">
									<template v-slot:front>
										<Illustration name="visits-realtor" />
										<div class="card__details">
											<p class="stat" v-html="_translate('m.usage.card.b.stat')"></p>
											<p v-html="_translate('m.usage.card.b.text')"></p>
										</div>
									</template>
								</Card>
								<p class="text-align-center" v-html="_translate('m.usage.intro.b')"></p>
							</div>
						</div>
					</section>

					<!-- Time Spent on site -->
					<section id="timeonsite">
						<h3>{{ _translate('m.time.title')}}</h3>
						<div class="grid grid--golden grid--gap">
	  					<Card class="pair" flip>
								<template v-slot:front>
									<h4 v-html="_translate('m.time.duration.title')"></h4>
									<div class="card__pair">
										<div class="card__pair-item">
											<Illustration name="website" />
											<div class="card__details">
												<p class="stat" v-html="_translate('m.time.card.a.text')"></p>
												<p v-html="_translate('m.time.card.a.stat')"></p>
											</div>
										</div>
										<div class="card__pair-item">
											<Illustration name="mobile-apps" />
											<div class="card__details">
												<p class="stat" v-html="_translate('m.time.card.b.text')"></p>
												<p v-html="_translate('m.time.card.b.stat')"></p>
											</div>
										</div>
									</div>
								</template>
								<template v-slot:rear>
									<p class="rear-details" v-html="_translate('m.time.card.rear')"></p>
								</template>
	  					</Card>
							<Card>
								<template v-slot:front>
									<Illustration name="average-mobile-time" />
									<div class="card__details card__details--no-stat">
										<!-- <p class="stat" v-html="_translate('m.time.card.c.stat')"></p> -->
										<p v-html="_translate('m.time.card.c.text')"></p>
									</div>
								</template>
	  					</Card>
	  				</div>
						<Card class="mono" flip>
							<template v-slot:front>
								<HeatMap :data="getHeatMapMobile" :title="_translate('m.heatmap.mobile.title')" />
							</template>
							<template v-slot:rear>
								<HeatMap :data="getHeatMapDesktop" :title="_translate('m.heatmap.desktop.title')" />
							</template>
						</Card>
					</section>

					<!-- Devices Used -->
					<section id="devicesused">
						<h3>{{ _translate('m.devices.title')}}</h3>
						<div class="grid grid--3-1 grid--gap">
							<div>
								<p v-html="_translate('m.devices.intro')" class="large"></p>
							</div>
							<Card class="side middle medium alignleft">
								<template v-slot:front>
									<Illustration name="visits-desktop" />
									<div class="card__details">
										<p class="stat" v-html="_translate('m.devices.card.a.stat')"></p>
										<p v-html="_translate('m.devices.card.a.text')"></p>
									</div>
								</template>
	  						</Card>
							<Card class="side middle medium alignleft">
								<template v-slot:front>
									<Illustration name="visits-mobile" />
									<div class="card__details">
										<p class="stat" v-html="_translate('m.devices.card.b.stat')"></p>
										<p v-html="_translate('m.devices.card.b.text')"></p>
									</div>
								</template>
								<!-- <template v-slot:rear>
									<p class="rear-details" v-html="_translate('m.devices.card.b.rear')"></p>
								</template> -->
	  						</Card>
	  				</div>
					</section>

					<InfoBox class="icon-left icon-red">
						<template v-slot:icon>
							<Icon icon="realtor-logo" />
						</template>
						<template v-slot:text>
							<p class="emphasis" v-html="_translate('m.realtorapp.paragraph.text')"></p>
						</template>
						<template v-slot:links>
							<div class="app-links">
                                <a class="app-link--apple" v-bind:href="_translate('m.realtorapp.applestore.href')" style="display: inline-block; overflow: hidden; border-radius: 13px; width: 250px; height: 68px;" target="_blank"><img v-bind:alt="_translate('m.realtorapp.applestore.alt')" v-bind:src="_translate('m.realtorapp.applestore.src')" style="border-radius: 13px; width: 250px; height: 83px;"></a>
                                <a class="app-link--google" v-bind:href="_translate('m.realtorapp.googleplay.href')" target="_blank"><img v-bind:alt="_translate('m.realtorapp.googleplay.alt')" v-bind:src="_translate('m.realtorapp.googleplay.src')"/></a>
								<!-- <a class="app-link--apple" href="https://apps.apple.com/ca/app/realtor-ca-real-estate-homes/id408873309?itsct=apps_box_badge&amp;itscg=30200" style="display: inline-block; overflow: hidden; border-radius: 13px; width: 250px; height: 68px;"><img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1591228800&h=0347c20784fc18bb5231c89d4c689010" alt="Download on the App Store" style="border-radius: 13px; width: 250px; height: 83px;"></a>
								<a class="app-link--google" href='https://play.google.com/store/apps/details?id=ca.crea.app.consumer&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/></a> -->
							</div>
						</template>
					</InfoBox>

					<!-- International -->
					<section id="international">
						<h3>{{ _translate('m.international.title')}}</h3>
						<div class="grid grid--3-1 grid--gap">
							<div>
								<p v-html="_translate('m.international.intro.a')"></p>
								<p v-html="_translate('m.international.intro.b')" class="emphasis"></p>
							</div>
							<Card class="side middle medium alignleft">
								<template v-slot:front>
									<Illustration name="international-visitors" />
									<div class="card__details">
										<p class="stat" v-html="_translate('m.international.card.a.stat')"></p>
										<p v-html="_translate('m.international.card.a.text')"></p>
									</div>
								</template>
	  					</Card>
							<Card class="side middle medium alignleft">
								<template v-slot:front>
									<Illustration name="international-leads" />
									<div class="card__details">
										<p class="stat" v-html="_translate('m.international.card.b.stat')"></p>
										<p v-html="_translate('m.international.card.b.text')"></p>
									</div>
								</template>
	  					</Card>
	  				</div>

					<InfoBox>
						<template v-slot:text>
							<p class="emphasis" v-html="_translate('m.creaglobal.paragraph.text')"></p>
						</template>
						<template v-slot:links>
							<a v-bind:href="_translate('m.creaglobal.link.href')" target="_blank">
								<span v-html="_translate('m.creaglobal.link.text')"></span>
								<Icon icon="ArrowRight"/>
							</a>
						</template>
					</InfoBox>


					<h4 v-html="_translate('m.topcountries.title')"></h4>
					<TopCountries :data="getTopCountries" />
					</section>

				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import BarChart from '@/components/BarChart.vue'
	import BehaviourChart from '@/components/BehaviourChart.vue'
	import BgBox from '@/components/BgBox.vue'
	import Card from '@/components/Card.vue'
	import Icon from '@/components/Icon.vue'
	import HeatMap from '@/components/HeatMap.vue'
	import Illustration from '@/components/Illustration.vue'
	import TopCountries from '@/components/TopCountries.vue'
	import reportNumbers from '@/content/reportNumbers.js'
	import InfoBox from '@/components/InfoBox.vue'

	export default {

	  name: 'BehaviouralInsights',

	  components: {
	  	BarChart,
	  	BehaviourChart,
	  	BgBox,
	  	Card,
	  	HeatMap,
	  	Illustration,
		Icon,
		TopCountries,
		InfoBox,
	  },

	  data: function() {

			return {
				mobile: reportNumbers.heatMapMobile,
				desktop: reportNumbers.heatMapDesktop,
				covidEffect: reportNumbers.covidEffect,
				topCountries: reportNumbers.topCountries
  		}

	  },

	  computed: {

	  	getHeatMapDesktop: function() {
	  		return this.$data.desktop;
	  	},

	  	getHeatMapMobile: function() {
	  		return this.$data.mobile;
	  	},

			getCovidData: function() {
				return this.$data.covidEffect;
			},

			getTopCountries: function() {
				return this.$data.topCountries;
			}


	  }

	}

</script>

<style lang="scss">

	.covid-chart {
		max-width: 40rem;
		margin: .5rem auto 1.5rem;

		h4 {
			margin-top: 0;
			margin-bottom: 2.5rem;
		}
	}

</style>